import { orchestrator } from 'satcheljs';
import { getGoDaddyDomainDetails } from '../services/getGoDaddyDomainDetails';
import { getPremiumLegacyTenant } from '../services/getPremiumLegacyTenant';
import PurchaseType from '../contracts/purchaseType';
import setGoDaddyDomainDetails from '../mutators/setGoDaddyDomainDetails';
import setPremiumLegacyTenant from '../mutators/setPremiumLegacyTenant';
import { getGoDaddyDomainDetails as getGoDaddyDomainDetailsAction } from '../actions/getGoDaddyDomainDetails';
import getPremiumUser from './getPremiumUser';
import store from '../store/store';
import { getWhoIsDomainDetails } from '../services/getWhoisDomainDetails';
import setTransferDomain from '../mutators/setTransferDomain';
import setIsInitializingGodaddyDomainDetails from '../mutators/setIsInitializingGodaddyDomainDetails';
import updateMXRecords from './updateMXRecords';

export default orchestrator(
    getGoDaddyDomainDetailsAction,
    async function getGoDaddyDomainDetailsAction() {
        if (
            !store.legacyPremiumUserDomainState.isInitializing &&
            store.legacyPremiumUserDomainState.authCode == ''
        ) {
            setIsInitializingGodaddyDomainDetails(true);
            getPremiumUser(null);
            if (
                store.legacyPremiumTenant.TenantName == '' &&
                store.userInfo.isProsumerConsumerMailbox
            ) {
                let legacyPremiumTenantResponse = await getPremiumLegacyTenant();
                setPremiumLegacyTenant(legacyPremiumTenantResponse);
                updateMXRecords('updateMXRecords');
                if (store.legacyPremiumTenant.TenantName != null) {
                    let response = await getWhoIsDomainDetails();
                    if (response.raw && response.raw.search('www.wildwestdomains.com') == -1) {
                        setTransferDomain(true);
                    } else {
                        setTransferDomain(false);
                    }
                }
            }
            if (store.legacyPremiumTenant.DomainPurchaseType == PurchaseType.AutoPurchased) {
                let response = await getGoDaddyDomainDetails(store.legacyPremiumTenant.TenantName);
                setGoDaddyDomainDetails(response);
            }
            setIsInitializingGodaddyDomainDetails(false);
        }
    }
);
